// ── Importaciones tal cual ──────────────────────────────
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from 'react-bootstrap';
import { LanguagesFetchAPI } from '../../api/Languages';
import LoadingAlert from '../Alerts/LoadingAlert';

import './BranchOfficeSelect.css'

/* ── Iconos (stroke currentColor) ── */
const IcoStore = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l1.5-5h15L21 9" /><path d="M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0" /><path d="M4 11v9h16v-9" /><path d="M10 20v-5h4v5" /></svg>;
const IcoAll = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /></svg>;
const IcoX = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
const IcoInfo = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>;
const IcoCheck = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>;
const IcoCaret = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>;

function ModalBranchofficeSelect({ actionSelectBranch }) {

  const [branchofficeName, setBranchofficeName] = useState("");
  const [showModalBranchofficeslect, setShowModalBranchofficesselect] = useState(false);
  const [statusLanguage, setStatusLanguage] = useState(0);
  let user = JSON.parse(localStorage.getItem('user'));
  let token = localStorage.getItem('x-access-token');
  const [userBranchoffices, setUserBranchs] = useState([]);

  const viewBranch = () => {
    const listItems = userBranchoffices.map((branch, index) => (
      /* .is-current es solo visual: resalta la sucursal ya persistida */
      <div className={`mbs-branch-item${branchofficeName === branch.branchoffice_name ? ' is-current' : ''}`} key={index}>
        <input
          type="radio" className="btn-check" name="items-branchs"
          id={branch.branchoffice_name + index}
          onClick={() => safeSelect(branch)}
        />
        <label
          className="mbs-branch-label btn-branchs card-title rounded-3 p-2 border border-primary text-center fw-semibold w-100 text-primary"
          translate="no" role="button"
          htmlFor={branch.branchoffice_name + index}
        >
          <div className="mbs-branch-label-ico"><IcoStore /></div>
          <div className="mbs-branch-label-body">
            <span className="mbs-branch-label-text">{branch.branchoffice_name}</span>
            {/* <span className="mbs-branch-label-sub">Sucursal</span> */}
          </div>
          {/* <span className="mbs-pill">Activa</span> */}
          <div className="mbs-branch-label-check"><IcoCheck /></div>
        </label>
      </div>
    ));
    return listItems;
  };

  const safeSelect = (branch) => {
    if (branch == 0) {
      actionSelectBranch(0);
      setShowModalBranchofficesselect(false);
      localStorage.setItem("branchoffice", "0");
      setBranchofficeName("Todas las sucursales");
    } else {
      actionSelectBranch(branch.code, branch);
      setShowModalBranchofficesselect(false);
      localStorage.setItem("branchoffice", JSON.stringify(branch));
      setBranchofficeName(branch.branchoffice_name);
    }
  };

  useEffect(() => {
    try {
      if (
        localStorage.getItem("branchoffice") == null ||
        localStorage.getItem("branchoffice") == undefined ||
        localStorage.getItem("branchoffice") == ""
      ) {
        setShowModalBranchofficesselect(true);
      } else {
        if (localStorage.getItem("branchoffice") === "0") {
          setBranchofficeName("Todas las sucursales");
          actionSelectBranch(0, { code: 0, branchoffice_name: "Todas las sucursales", branchoffice_id: 0 });
        } else {
          setBranchofficeName(JSON.parse(localStorage.getItem("branchoffice")).branchoffice_name);
          actionSelectBranch(
            JSON.parse(localStorage.getItem("branchoffice")).code,
            JSON.parse(localStorage.getItem("branchoffice"))
          );
        }
      }
      setUserBranchs(user.branchoffices);
    } catch (err) { }
    console.log("UseEffect Modal sucursal fin", user);
  }, []);

  return (
    <>
      {/* ── TRIGGER ── */}
      <button
        className="mbs-trigger btn-branchs card-title rounded-3 p-1 border border-primary text-center"
        onClick={() => { setShowModalBranchofficesselect(true); console.log(userBranchoffices); }}
      >
        <span className="mbs-trigger-ico"><IcoStore /></span>
        <span className="mbs-trigger-body">
          <small className="mbs-trigger-label d-block fw-semibold" role="button">Sucursal</small>
          <span className={`mbs-trigger-name fw-semibold${!branchofficeName ? ' empty' : ''}`} role="button">
            {branchofficeName || 'Seleccionar…'}
          </span>
        </span>
        <span className="mbs-trigger-caret"><IcoCaret /></span>
      </button>

      {/* ── MODAL ── */}
      <Modal
        centered
        className="modal-dialog-kk"
        size="md"
        show={showModalBranchofficeslect}
        onHide={() => setShowModalBranchofficesselect(false)}
        dialogClassName="mbs-dialog"
      >
        <Modal.Body>

          {/* header: título + contador + cerrar */}
          <div className="mbs-head">
            <div className="mbs-head-title">
              <h2 className="mbs-title">Sucursal</h2>
              <span className="mbs-count">{userBranchoffices.length}</span>
            </div>
            <button
              className="mbs-icon-btn mbs-icon-btn--danger" type="button" title="Cerrar" aria-label="Cerrar"
              onClick={() => setShowModalBranchofficesselect(false)}
            >
              <IcoX />
            </button>
          </div>

          {/* meta: selección actual */}
          <div className="mbs-meta">
            <span className="mbs-meta-key">Selección actual</span>
            <span className={`mbs-meta-val${!branchofficeName ? ' empty' : ''}`}>
              <span className="mbs-meta-dot" />
              {branchofficeName || 'Sin seleccionar'}
            </span>
          </div>

          {/* lista */}
          <div className="mbs-section">
            <div className="mbs-section-head">
              <span className="mbs-section-label">Elige una sucursal</span>
              <span className="mbs-section-count">
                {userBranchoffices.length} disponible{userBranchoffices.length !== 1 ? 's' : ''}
              </span>
            </div>
            <div className="mbs-list">
              {/* "Todas" — lógica original intacta */}
              <div className={`mbs-branch-item all-item${branchofficeName === 'Todas las sucursales' ? ' is-current' : ''}`}>
                <input type="radio" className="btn-check" name="items-branchs" id="all" onClick={() => safeSelect(0)} />
                <label
                  className="mbs-branch-label btn-branchs card-title rounded-3 p-2 border border-primary text-center fw-semibold w-100 text-primary"
                  htmlFor="all" role="button"
                >
                  <div className="mbs-branch-label-ico"><IcoAll /></div>
                  <div className="mbs-branch-label-body">
                    <span className="mbs-branch-label-text">Todas las sucursales</span>
                    <span className="mbs-branch-label-sub">Vista combinada</span>
                  </div>               
                  <div className="mbs-branch-label-check"><IcoCheck /></div>
                </label>
              </div>
              {/* viewBranch() — lógica original intacta */}
              {viewBranch()}
            </div>
          </div>

          {/* footer */}
          <div className="mbs-foot">
            <span className="mbs-foot-hint">
              <IcoInfo /> Puedes cambiar de sucursal en cualquier momento
            </span>
          </div>

          {/* estructura original oculta — preserva clases del proyecto */}
          <div style={{ display: 'none' }}>
            <div className="idioma-sp position-relative">
              <section className="form-signin-sp bg-white border-0">
                <h2 className="title-main-login text-center"><i className="uil uil-store-alt" />Sucursales</h2>
                <div className="pb-4">
                  <label className="form-label fw-normal text-gray-600">Lista de sucursales</label>
                  <div className="branch-wrapper no-scroll">
                    <div className="d-flex flex-column gap-3 p-2 bg-body">
                      <input type="radio" className="btn-check" name="items-branchs" id="all-orig" onClick={() => safeSelect(0)} />
                      <label className="btn-branchs card-title rounded-3 p-2 border border-primary text-center fw-semibold w-100 text-primary" htmlFor="all-orig" role="button">
                        <span>Todas las sucursales</span>
                      </label>
                    </div>
                  </div>
                  <div className="d-block text-center mt-3 opacity-50">
                    <i className="uil uil-info-circle" /> Escoge la sucursal de tu preferencia.
                  </div>
                </div>
              </section>
              <div className="position-absolute top-0 start-100 translate-middle mt-2">
                <div className="me-3">
                  <button className="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1" type="button" onClick={() => setShowModalBranchofficesselect(false)} title="Cerrar">
                    <i className="uil uil-multiply" /><span className="visually-hidden">Dismiss</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </Modal.Body>
      </Modal>

      {void [Button, LanguagesFetchAPI, LoadingAlert, statusLanguage, token]}
    </>
  );
}

export default ModalBranchofficeSelect;